export const ROOT_ORG_CHILD_LEVEL_VARIANT_UNIQUE_IDS = [
  'head-tenant-lvl-variant',
] as const

export const HEAD_TENANT_CHILD_LEVEL_VARIANT_UNIQUE_IDS = [
  'branch-lvl-variant',
] as const

export const TENANT_CHILD_LEVEL_VARIANT_UNIQUE_IDS = [
  'branch-lvl-variant',
] as const

export const getDefaultChildLevelVariantUniqueIds = (currentUniqueId: string): ReadonlySet<string> | null => {
  if (currentUniqueId === 'root-org-lvl-variant') {
    return new Set(ROOT_ORG_CHILD_LEVEL_VARIANT_UNIQUE_IDS)
  }

  if (currentUniqueId === 'head-tenant-lvl-variant') {
    return new Set(HEAD_TENANT_CHILD_LEVEL_VARIANT_UNIQUE_IDS)
  }

  if (currentUniqueId === 'tenant-lvl-variant') {
    return new Set(TENANT_CHILD_LEVEL_VARIANT_UNIQUE_IDS)
  }

  return null
}
